import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
    discussionSocketEvents,
    DISCUSSION_COMMENT_TYPE,
} from 'src/app/shared/global/constants';
import { DiscussionSocketService } from 'src/app/shared/services/discussion/discussion-socket.service';
import { TasksService } from 'src/app/shared/services/task-service/tasks.service';

@Component({
    selector: 'app-checklist-comment',
    templateUrl: './checklist-comment.component.html',
    styleUrls: ['./checklist-comment.component.scss'],
})
export class ChecklistCommentComponent implements OnInit {
    selectedRoom: any = {};
    searchText = '';

    constructor(
    public taskService: TasksService,
    private discussionSocketService: DiscussionSocketService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ChecklistCommentComponent>
    ) {}

    ngOnInit() {
        this.getTaskDetails();
    }

    getTaskDetails() {
    // this.taskService.selectedTaskDetails.subscribe(response => {
    //   if(response) {
    //     this.selectedRoom = {
    //       _id: response.task_id,
    //       user_id: response.owner.user_id,
    //       title: response.task_name,
    //       project_id: null,
    //       task_id: response.task_id,
    //       color: "#DC3535",
    //       created_by: response.owner,
    //       accesses: response.assignees ? [...response.assignees] : [],
    //       type: DISCUSSION_COMMENT_TYPE.TASK
    //     };
    //     this.selectedRoom.accesses.push(response.owner);
    //     this.discussionSocketService.emit(discussionSocketEvents.JOIN_ROOM, {
    //       id: response._id,
    //     });
    //   }
    // });
    }

    close() {
        this.dialogRef.close(true);
    }

    search(searchText: any) {
    // this.taskService.checklistCommentSearch(searchText);
    }
}
